module.exports = __webpack_public_path__ + "static/img/cert-02.6bf2b4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cert/cert-02.png
// module id = omnu
// module chunks = 1